module.exports = __webpack_public_path__ + "static/media/edek2.cedd8467.png";